
export const permisosPorRol = {
  ADMIN: {
    Solicitudes: {
      Crear: true,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: true,
        ReintentarRedencion: true,
        FolioManual: true,
        CancelarRedencion: true,
        PorExcepcion:true
      }
    },
    Polizas: {
      Crear: true,
      Ver: true,
      Editar: {
        DatosDelCliente: true,
        Cancelar: false,
        Reactivar: false
      }
    },
    Beneficiarios: {
      Crear: true,
      Ver: true,
      Editar: true
    },
    Cuotas: {
      Crear: true,
      Ver: true,
      Editar: true
    },
    Clientes: {
      Crear: true,
      Ver: true,
      Editar: true
    },
    Usuarios: {
      Crear: true,
      Ver: true,
      Editar: true
    }
  },
  ADMINALIANZA: {
    Solicitudes: {
      Crear: false,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: true,
        ReintentarRedencion: true,
        FolioManual: false,
        CancelarRedencion: false,
        PorExcepcion:false
      }
    },
    Polizas: {
      Crear: false,
      Ver: true,
      Editar: {
        DatosDelCliente: false,
        Cancelar: false,
        Reactivar: false
      }
    },
    Beneficiarios: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Cuotas: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Clientes: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Usuarios: {
      Crear: true,
      Ver: true,
      Editar: true
    }
  },
  GERENTEALIANZA: {
    Solicitudes: {
      Crear: false,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: true,
        ReintentarRedencion: true,
        FolioManual: true,
        CancelarRedencion: true,
        PorExcepcion:true
      }
    },
    Polizas: {
      Crear: false,
      Ver: true,
      Editar: {
        DatosDelCliente: false,
        Cancelar: false,
        Reactivar: false
      }
    },
    Beneficiarios: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Cuotas: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Clientes: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Usuarios: {
      Crear: true,
      Ver: true,
      Editar: true
    }
  },
  COORDINADORALIANZA: {
    Solicitudes: {
      Crear: false,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: true,
        ReintentarRedencion: true,
        FolioManual: true,
        CancelarRedencion: true,
        PorExcepcion:true
      }
    },
    Polizas: {
      Crear: false,
      Ver: true,
      Editar: {
        DatosDelCliente: true,
        Cancelar: true,
        Reactivar: true
      }
    },
    Beneficiarios: {
      Crear: true,
      Ver: true,
      Editar: true
    },
    Cuotas: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Clientes: {
      Crear: false,
      Ver: true,
      Editar: true
    },
    Usuarios: {
      Crear: true,
      Ver: true,
      Editar: true
    }
  },
  SUPERVISORALIANZA: {
    Solicitudes: {
      Crear: true,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: true,
        ReintentarRedencion: true,
        FolioManual: true,
        CancelarRedencion: true,
        PorExcepcion:true
      }
    },
    Polizas: {
      Crear: false,
      Ver: true,
      Editar: {
        DatosDelCliente: true,
        Cancelar: true,
        Reactivar: true
      }
    },
    Beneficiarios: {
      Crear: true,
      Ver: true,
      Editar: true
    },
    Cuotas: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Clientes: {
      Crear: false,
      Ver: true,
      Editar: true
    },
    Usuarios: {
      Crear: true,
      Ver: true,
      Editar: true
    }
  },
  OPERADORSERVICIOSALIANZA: {
    Solicitudes: {
      Crear: true,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: true,
        ReintentarRedencion: true,
        FolioManual: true,
        CancelarRedencion: true,
        PorExcepcion:true
      }
    },
    Polizas: {
      Crear: false,
      Ver: true,
      Editar: {
        DatosDelCliente: true,
        Cancelar: true,
        Reactivar: false
      }
    },
    Beneficiarios: {
      Crear: true,
      Ver: true,
      Editar: true
    },
    Cuotas: {
      Crear: false,
      Ver: true,
      Editar: false
    },
    Clientes: {
      Crear: false,
      Ver: true,
      Editar: true
    },
    Usuarios: {
      Crear: false,
      Ver: true,
      Editar: true
    }
  },
  EJECUTIVOGABSSA: {
    Solicitudes: {
      Crear: true,
      Ver: true,
      Editar: {
        ValidarSaldoInspirum: false,
        ReintentarRedencion: true,
        FolioManual: false,
        CancelarRedencion: true,
        PorExcepcion:false
      },
      CrearRedencionRedencionSinEmision:true
    },
    Usuarios: {
      Crear: false,
      Ver: true,
      Editar: true
    }
  }
}
